import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/web/src/entities/TelegramBackButton/ui/TelegramBackButton.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/web/src/features/CartIconBadge/ui/CartIconBadge.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/web/src/features/Search/ui/Search.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/web/src/features/Search/ui/SearchTrigger.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/web/src/features/Sidebar/ui/Sidebar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/web/src/features/Sidebar/ui/SidebarTrigger.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/web/src/shared/assets/brand/logo.svg");
;
import(/* webpackMode: "eager" */ "/app/apps/web/src/shared/assets/icons/favourite.svg");
;
import(/* webpackMode: "eager" */ "/app/apps/web/src/shared/assets/icons/hamburger.svg");
;
import(/* webpackMode: "eager" */ "/app/apps/web/src/shared/assets/icons/profile.svg");
;
import(/* webpackMode: "eager" */ "/app/apps/web/src/shared/assets/icons/search.svg");
;
import(/* webpackMode: "eager", webpackExports: ["Categories"] */ "/app/apps/web/src/widgets/Header/ui/Categories.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CategoryTrigger"] */ "/app/apps/web/src/widgets/Header/ui/CategoryTrigger.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeaderNavLink"] */ "/app/apps/web/src/widgets/Header/ui/HeaderNavLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LocaleSwitcher"] */ "/app/apps/web/src/widgets/Header/ui/LocaleSwitcher.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Search"] */ "/app/apps/web/src/widgets/Header/ui/Search.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/.pnpm/next-intl@3.26.5_next@15.5.25_react-dom@19.0.3_react@19.0.3__react@19.0.3_sass@1.89.1__react@19.0.3/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/.pnpm/next-intl@3.26.5_next@15.5.25_react-dom@19.0.3_react@19.0.3__react@19.0.3_sass@1.89.1__react@19.0.3/node_modules/next-intl/dist/esm/navigation/shared/LegacyBaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/.pnpm/next@15.5.25_@babel+core@7.27.4_react-dom@19.0.3_react@19.0.3__react@19.0.3_sass@1.89.1/node_modules/next/dist/client/app-dir/link.js");
